export default "__VITE_ASSET__BTkxAs8a__"